import React from 'react';

import { AGE_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { useFilterCount } from '../hooks';

export const ApparentAgeCheckboxesPopover = ({ onCountChange, ...props }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const selectedApparentAge = useWatch({ name: 'apparent_age' });
  const filterCount = selectedApparentAge ? 1 : 0;
  useFilterCount('apparent_age', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="apparentAgeFilter"
      triggerValue={t('events:body basic attributes.apparent age')}
      {...props}
    >
      <CheckboxCustomFilter
        control={control}
        name="apparent_age"
        options={AGE_OPTIONS.raw}
      />
    </CustomFilterPopover>
  );
};
